import React from 'react';
import { connect } from 'react-redux';
import {Modal, Row, Col, Spin, Form, Button} from 'antd';

import { Select, Input ,Checkbox } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    addErroTip = () =>{
        let  info = document.getElementById("sign/operationRecords/edit.js/add").value;
        if(info!=undefined && info!=null && info.trim()!=""){
            this.props.addErroTip([{ label: info, value: info,key:this.props.erroTip.length}]);
        }
    }
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if (this.props.item.id === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    values["id"] = this.props.item.id;
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const {erroTip} = this.props;
        const {allMonitorName} = this.props;
        let taskMonitorList1 = new Array();
        allMonitorName.forEach(
            taskInfo =>{
                taskMonitorList1.push(taskInfo['monitoringName']);
            }
        );
        let i =0;
        const allMonitor = taskMonitorList1.map(item => {
            return (
                <Option key={i} value={item}>
                    {item}
                </Option>
            );
            i++;
        });
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="标题">
                            {getFieldDecorator('title', {
                                initialValue: item.title,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入标题',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}  />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="关联任务">
                            {getFieldDecorator('concactTask', {
                                initialValue: item.concactTask ,
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="检测公司">
                            {getFieldDecorator('monitorName', {
                                initialValue: item.monitorName,
                            })(
                                <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                    {allMonitor}
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="异常标签">
                            {getFieldDecorator('erroTip', {
                                initialValue: item.erroTip,
                            })(
                                <Checkbox.Group
                                    options={erroTip}
                                />
                            )}
                            <Col>
                            <Input   style={{ width: 100 }} placeholder="添加标签"  id="sign/operationRecords/edit.js/add"/>
                                &nbsp;&nbsp;&nbsp;<Button  onClick={this.addErroTip}>添加</Button></Col>
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="异常摘要">
                            {getFieldDecorator('erroMark', {
                                initialValue: item.erroMark,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入异常摘要',
                                    },
                                ],
                            })(
                                <TextArea rows={10} placeholder="请填写异常摘要" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="异常原因">
                            {getFieldDecorator('erroReason', {
                                initialValue: item.erroReason,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入异常原因',
                                    },
                                ],
                            })(
                                <TextArea rows={10} placeholder="请填写异常原因" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="解决方法">
                            {getFieldDecorator('resolvent', {
                                initialValue: item.resolvent,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入解决方法',
                                    },
                                ],
                            })(
                                <TextArea rows={10} placeholder="请填写解决方法" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.operationRecords.list.reduce((a, b) => (b.id === state.operationRecords.currentSelectId ? b : a), {}),
    isModalShow: state.operationRecords.uiStatus.isUpdateShow,
    isLoading: state.operationRecords.uiStatus.isLoading,
    pricpleList: state.operationRecords.pricpleList,
    erroTip: state.operationRecords.erroTip,
    allMonitorName: state.operationRecords.allMonitorName,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
    getErroTip: () => dispatch(actions.getErroTip()),
    addErroTip: (data) => dispatch(actions.addErroTip(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/sign/operationRecords/edit.js